import React from 'react';
import '../../assets/styles/SuperAdmin/SATheme.css';

const SABadge = ({ color = "green", children, dot }) => {
    const colors = {
        green: "var(--sa-green)",
        red: "var(--sa-red)",
        orange: "var(--sa-orange)",
        blue: "var(--sa-blue)",
        teal: "var(--sa-teal)",
        purple: "var(--sa-purple)",
        gold: "var(--sa-gold)"
    };

    const c = colors[color] || colors.green;

    return (
        <span className="sa-badge" style={{ background: `${c}16`, color: c, border: `1px solid ${c}30` }}>
            {dot && <span className="sa-badge-dot" style={{ background: c }} />}
            {children}
        </span>
    );
};

export default SABadge;
